<div class="container-fluid">
  <div class="d-flex gap-1 mt-2">


    <!-- Use shared searchable-select component with multiple + Select All support -->
    <div class="col-md-3">
      <app-searchable-select
        [options]="counsellors$ | async"
        displayKey="userName"
        [valueKey]="'userName'"
        [multiple]="true"
        [hideSelectAllOption]="false"
        placeholder="Select Counsellor"
        label="Counsellor Name"
        [selectedValue]="selectedCounsellors"
        (selectionChange)="onCounsellorsSelected($event)"
      ></app-searchable-select>
    </div>

    <mat-form-field appearance="outline" class="col-md-3">
      <mat-label>Enter a date range</mat-label>
      <mat-date-range-input [rangePicker]="picker">
        <input matStartDate [(ngModel)]="start" placeholder="Start date">
        <input matEndDate [(ngModel)]="end" placeholder="End date">
      </mat-date-range-input>
      <mat-hint>DD/MM/YYYY – DD/MM/YYYY</mat-hint>
      <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
      <mat-date-range-picker #picker></mat-date-range-picker>
    </mat-form-field>&nbsp;

    <button mat-mini-fab color="accent" (click)="onSearch()" matTooltip="Search">
      <mat-icon>search</mat-icon>
    </button>
    <button mat-mini-fab color="accent" (click)="onClear()" matTooltip="Clear Filters">
      <mat-icon>clear</mat-icon>
    </button>
  </div>

  <div class="ngxTableHeader">
    <ul class="header-buttons-left ms-0 mb-0">
      <li class="dropdown">
        <h2>Counselling Work Update List</h2>
      </li>
      <li class="dropdown m-l-20">
        <label for="search-input"><i class="material-icons search-icon">search</i></label>
        <input placeholder="Search" type="text" class="browser-default search-field"
               (keyup)='applyFilter($event)' aria-label="Search box" #input>
      </li>
    </ul>
    <ul class="header-buttons mr-2">
      <li>
        <button mat-mini-fab color="primary" (click)="Add()" permission="Work Updates" [permissionTypes]="[PermissionType.ALL, PermissionType.ADD]">
          <mat-icon class="col-white">add</mat-icon>
        </button>
      </li>
    </ul>
  </div>

  <table mat-table [dataSource]="dataSource" class="mat-elevation-z2 w-100">

    <ng-container matColumnDef="date">
      <th mat-header-cell *matHeaderCellDef>Date</th>
      <td mat-cell *matCellDef="let row">{{ row.date.toDate() | date }}</td>
    </ng-container>

    <ng-container matColumnDef="centre">
      <th mat-header-cell *matHeaderCellDef>Centre</th>
      <td mat-cell *matCellDef="let row">
        <ng-container *ngIf="row.centre?.length > 0; else oldCentre">

    <span matTooltip="{{ getAllCentreNames(row) }}">
      {{ row.centre[0]?.centreName }}
      <span *ngIf="row.centre.length > 1">
        +{{ row.centre.length - 1 }} more
      </span>
    </span>

        </ng-container>

        <ng-template #oldCentre>
          {{ row.centreName }}
        </ng-template>
      </td>
    </ng-container>

    <ng-container matColumnDef="submittedBy">
      <th mat-header-cell *matHeaderCellDef>Counsellor</th>
      <td mat-cell *matCellDef="let row">{{ row.counsellorName }}</td>
    </ng-container>

    <ng-container matColumnDef="task">
      <th mat-header-cell *matHeaderCellDef> Task</th>
      <td mat-cell *matCellDef="let row">
        <span matTooltip="{{ row?.task }}" matTooltipPosition="above">
          {{ row?.task?.length > 15 ? (row?.task | slice:0:15) + '...' : row?.task }}
        </span>
      </td>
    </ng-container>

    <ng-container matColumnDef="userSubmittedBy">
      <th mat-header-cell *matHeaderCellDef>Submitted By</th>
      <td mat-cell *matCellDef="let row">{{ row.counsellorName }}</td>
    </ng-container>

    <ng-container matColumnDef="actions">
      <th mat-header-cell *matHeaderCellDef>Action</th>
      <td mat-cell *matCellDef="let element">
        <div class="d-flex">
          <button mat-icon-button color="primary" permission="Work Updates" [permissionTypes]="[PermissionType.ALL, PermissionType.VIEW]" (click)="viewServicingDetails(element)" matTooltip="View">
            <mat-icon>visibility</mat-icon>
          </button>
          <button mat-icon-button color="primary" permission="Work Updates" [permissionTypes]="[PermissionType.ALL, PermissionType.EDIT]" (click)="viewEdit(element?.id)" matTooltip="Edit">
            <mat-icon>edit</mat-icon>
          </button>
          <button *ngIf="canShowDelete(element)" permission="Work Updates" [permissionTypes]="[PermissionType.ALL, PermissionType.ARCHIVE]" mat-icon-button color="warn" (click)="delete(element.id)" matTooltip="Delete">
            <mat-icon>delete</mat-icon>
          </button>
        </div>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

  </table>

  <mat-paginator [pageSizeOptions]="[5, 10, 25]" showFirstLastButtons></mat-paginator>
</div>
